import React, { useContext, useEffect, useState } from "react";
import "./style.css";
import EventCard from "../EventCard";
import Slider from "react-slick";
import { filterDataContext } from "../../App";
import { getDataFromApi } from "../../APIs";

const EventSlider = ({ dataX }) => {
  const settings = {
    dots: false,
    // infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    rows: 1,
    centerMode: false,
    speed: 500,
    cssEase: "linear",
    arrow: true,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          rows: 1,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1.01,
          slidesToScroll: 1,
          centerMode: true,
          rows: 1,
        },
      },
    ],
  };

  return (
    <>
      <div
        className={`slider_home_page ${dataX.length <= 3 ? "active" : ""} ${
          dataX.length === 1 && "singleEvent"
        }`}
      >
        {dataX.length <= 3 &&
          dataX?.map((item, index) => {
            return (
              <div className="min_Cards" key={index}>
                <EventCard key={index} CardData={item} />
              </div>
            );
          })}
      </div>
      <div className="slider_home_page">
        {dataX.length > 3 && (
          <Slider {...settings} style={{ width: "100%" }}>
            {dataX?.map((item, index) => {
              return <EventCard key={index} CardData={item} />;
            })}
          </Slider>
        )}
      </div>
    </>
  );
};

export default EventSlider;
